import React, { useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NAV_ITEMS = [
  { path: '/', label: 'Dashboard', icon: '📊' },
  { path: '/onboarding', label: 'Onboarding', icon: '🚀' },
  { path: '/chat', label: 'Ask KATI', icon: '💬' },
  { path: '/memory', label: 'Memory Search', icon: '🔍' },
  { path: '/tickets', label: 'Tickets', icon: '🎫' },
  { path: '/incidents', label: 'Incidents', icon: '🔔' },
  { path: '/documents', label: 'Documents', icon: '📚' },
  { path: '/github', label: 'GitHub', icon: '🐙' },
  { path: '/organization', label: 'Organization', icon: '🏢' },
];

const Sidebar = React.memo(({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = useCallback(() => {
    logout();
    navigate('/login');
  }, [logout, navigate]);

  const userInitials = useMemo(() => {
    if (!user?.name) {
      return '';
    }
    return user.name
      .split(' ')
      .filter(Boolean)
      .map((namePart) => namePart[0])
      .join('')
      .toUpperCase();
  }, [user?.name]);

  return (
    <div className="sidebar" data-testid="sidebar">
      <div className="sidebar-header">
        <div className="logo" data-testid="logo">
          <div className="logo-icon">K</div>
          KATI
        </div>
      </div>
      
      <nav className="sidebar-nav" data-testid="sidebar-nav">
        {NAV_ITEMS.map((item) => (
          <div
            key={item.path}
            data-testid={`nav-item-${item.label.toLowerCase().replace(' ', '-')}`}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <span className="nav-icon">{item.icon}</span>
            {item.label}
          </div>
        ))}
      </nav>

      {user && (
        <div className="user-profile" data-testid="user-profile">
          <div className="user-info">
            <div className="user-avatar" data-testid="user-avatar">
              {user.picture ? (
                <img src={user.picture} alt={user.name} style={{ width: '100%', height: '100%', borderRadius: '50%' }} />
              ) : (
                userInitials
              )}
            </div>
            <div className="user-details">
              <h4>{user.name}</h4>
              <p>{user.email}</p>
            </div>
          </div>
          <button
            data-testid="logout-btn"
            onClick={handleLogout}
            style={{
              marginTop: '12px',
              width: '100%',
              padding: '8px 12px',
              background: '#f1f5f9',
              border: 'none',
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: '600',
              color: '#64748b',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#e2e8f0';
              e.target.style.color = '#475569';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#f1f5f9';
              e.target.style.color = '#64748b';
            }}
          >
            🚪 Logout
          </button>
        </div>
      )}
    </div>
  );
});

export default Sidebar;
